import { render, staticRenderFns } from "./NewsMediaArticles.vue?vue&type=template&id=2b5fab34&"
import script from "./NewsMediaArticles.vue?vue&type=script&lang=js&"
export * from "./NewsMediaArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports